<template>
  <v-card>
    <v-toolbar color="secondary" class="elevation-0">
      <v-toolbar-title> Tenants </v-toolbar-title>
    </v-toolbar>
    <v-card-actions>
      <div>
        <v-menu :close-on-content-click="false" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-bind="attrs"
              v-on="on"
              dense
              outlined
              :value="startDate"
              prepend-inner-icon="mdi-calendar-clock"
              append-inner-icon="mdi-menu-down"
              class="mx-5"
              style="height: 40px; min-width: 180px"
              label="From"
              hide-details
            />
          </template>
          <v-list class="pa-0" style="max-width: fit-content">
            <v-list-item class="pa-0">
              <v-list-item-title>
                <v-date-picker
                  v-model="startDate"
                  show-adjacent-months
                  :max="endDate"
                />
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <div>
        <v-menu :close-on-content-click="false" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-bind="attrs"
              v-on="on"
              dense
              outlined
              :value="endDate"
              prepend-inner-icon="mdi-calendar-clock"
              append-inner-icon="mdi-menu-down"
              class="mx-5"
              style="height: 40px; min-width: 180px"
              label="To"
              hide-details
            />
          </template>
          <v-list class="pa-0" style="max-width: fit-content">
            <v-list-item class="pa-0">
              <v-list-item-title>
                <v-date-picker
                  v-model="endDate"
                  show-adjacent-months
                  :min="startDate"
                />
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        outlined
        dense
        hide-details
      ></v-text-field>
    </v-card-actions>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="items"
        dense
        :items-per-page="15"
        :search="search"
        @click:row="openDetail"
      >
        <template v-slot:[`item.details`]="{ item }">
          <v-btn icon @click.stop="showDetails(item)">
            <v-icon>mdi-clipboard-outline</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>

    <v-dialog v-model="detailsDialog" width="500">
      <v-card>
        <v-toolbar color="secondary" class="elevation-0">
          <v-toolbar-title>
            {{ this.item?.name }} - {{ this.item?.country }}
          </v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="detailsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-5 px-5">
          <pre class="text-body-1">{{
            JSON.stringify(this.item?.details, null, 2)
          }}</pre>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { formatDate, endOfDay } from "@/lib/utils";

const DAY_IN_MS = 24 * 60 * 60 * 1000;
const defaultStart = new Date(new Date().getTime() - 365 * DAY_IN_MS);
const defaultEnd = new Date();

export default {
  data: () => ({
    loading: false,
    detailsDialog: false,
    startDate: formatDate(defaultStart),
    endDate: formatDate(defaultEnd),
    item: null,
    search: null,
    headers: [
      { text: "Name", value: "name" },
      { text: "Country", value: "country" },
      { text: "Email", value: "email" },
      { text: "Phone", value: "phone" },
      { text: "Created", value: "created_at" },
      { text: "Details", value: "details" },
    ],
  }),

  watch: {
    detailDialog(val) {
      if (!val) this.item = null;
    },
  },

  computed: {
    ...mapGetters(["tenants"]),
    items() {
      return this.tenants
        ?.filter(
          (t) =>
            new Date(t.created_at) >= new Date(this.startDate) &&
            new Date(t.created_at) < endOfDay(this.endDate)
        )
        .map((t) => ({
          name: t.name,
          country: t.shipping_country,
          email: t.email_address,
          phone: t.phone_number,
          created_at: new Date(t.created_at).toLocaleDateString(),
          details: t,
        }));
    },
  },

  methods: {
    showDetails(item) {
      this.item = item;
      this.detailsDialog = true;
    },
    openDetail(item) {
      this.$router.push("/tenants/" + item.details.uid);
    },
  },
};
</script>
